import React from 'react'
// import { useSelector } from 'react-redux'
import Gamess from '../data/games.json'
import Mainlayout from '../layout/Mainlayout'
// import userxals from '../data/usersxal.json'

export default function Allusersxal() {

    // const xal = []
    const xals = []
    // const user = useSelector((state) => state.user)
    const peshbini = JSON.parse(localStorage.getItem('peshbiniakan'));

    
        peshbini.map((peshbini) => {
            const game = Gamess[peshbini.id - 1]

            
            if (peshbini.result === game.result) {
                
                const info = {
    
                    "username": `${peshbini.username}`,
                    "userImage": `${peshbini.userImage}`,
                    "gametype": `${peshbini.gametype}`,
                    "xal": `${1}`
                }
                
                xals.push(info)

            }
            
            return(
                <>

                    
                </>
            )
                
             

        })
    

console.log(xals)

    return (
        <Mainlayout>
            <div className='bg-dwam'>
                
            
            </div>
        </Mainlayout>
    )
}
